import { render } from "./ItemModal.vue?vue&type=template&id=4283834c&scoped=true"
import script from "./ItemModal.vue?vue&type=script&lang=js"
export * from "./ItemModal.vue?vue&type=script&lang=js"

import "@/assets/css/shared/itemModal.css?vue&type=style&index=0&id=4283834c&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4283834c"],['__file',"src/components/ItemModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4283834c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4283834c', __exports__)) {
    api.reload('4283834c', __exports__)
  }
  
  module.hot.accept("./ItemModal.vue?vue&type=template&id=4283834c&scoped=true", () => {
    api.rerender('4283834c', render)
  })

}


export default __exports__